import { HashMap } from "../../shared/model/HashMap";
import { EnvironmentVariableSchemaDescription } from "../components/PanelContent";

export enum SchemaType {
    String = "String",
    Secret = "Secret",
    Number = "Number",
    Boolean = "Boolean",
    Array = "Array",
    Object = "Object"
}

export interface VariableSchema {
    id?: number | null;
    name: string | undefined;
    type: SchemaType | undefined;
    parentSchemaId: number | undefined | null;
    description: EnvironmentVariableSchemaDescription | undefined;
}

export interface ImportResult {
    askForOverwriteConfirmation: boolean;
    valueUpdates: HashMap<HashMap<VariableValue>>;
    valueUpdatesCount: number;
    logs: string[];
    errors: string[];
    importedEnvironmentVariables: string[];
}

export interface VariableValue {
    id: number | null;
    environmentId: number;
    schemaId: number;
    modifiedUtc: string | null;
    modifier: string | null;
    version: number;
    value: any;
    isDirty: boolean;
    originalValue?: boolean;
    type?: SchemaType;
    name?: string;
    parentSchemaId?: number;
    parentSchemaName?: string;
    description?: EnvironmentVariableSchemaDescription;
}

export interface IObjectSchema {
    id: number;
    description: EnvironmentVariableSchemaDescription;
}
